export function createComputerAutomationClientId(): string {
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  return `computer-${Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("")}`;
}
